import './labListScreen.scss'
import React, {useCallback, useEffect, useState} from 'react';
import {CommonService} from "../../shared/services";
import LabListComponent from "./lab-list-component/labListComponent";
import ButtonComponent from "../../shared/components/core/button/ButtonComponent";
import AddIcon from "@mui/icons-material/Add";
import {useNavigate} from "react-router-dom";
import DrawerComponent from "../../shared/components/drawer/drawerComponent";
import LabFiltersComponent from "./lab-filters/LabFiltersComponent";
import FilterAltIcon from "@mui/icons-material/FilterAlt";
import {setCurrentNavParams, setSideMenuView} from "../../store/actions/header.action";
import {useDispatch, useSelector} from "react-redux";
import {IRootReducerState} from "../../store/reducers";
import _ from "lodash";
import SearchComponent from "../../shared/components/search/SearchComponent";
import commonService from "../../shared/services/common.service";
import LabRoleSelectionComponent from "../../shared/components/labRoleSelection/LabRoleSelectionComponent";
import {LabRoleType} from "../../shared/models/lab.model";

interface LabListScreenProps {

};

const FiltersInitialState: any = {
    search: '',
    labTypes: [],
    labTypesObjs: [],
    createdByObjs: [],
    createdByIds: [],
    statuses: [],
    statusesObjs: [],
    cities: [],
    citiesObjs: [],
    startDate: '',
    endDate: ''
}

const FILTERS_STATE_MANAGEMENT_EXCLUDE_KEYS = ['statusesObjs', 'createdByObjs', 'labTypesObjs', 'citiesObjs'];


const LabListScreen = (props: LabListScreenProps) => {
        const navigate = useNavigate()
        const [showFilterDrawer, setShowFiltersDrawer] = useState<boolean>(false);
        const dispatch = useDispatch();
        const {queryParamData} = useSelector((state: IRootReducerState) => state.stateManagement);
        const {currentUser} = useSelector((state: IRootReducerState) => state.account);
        const {labStatusList, userList, citiesListLite} = useSelector((state: IRootReducerState) => state.staticData);
        const [filterData, setFilterData] = useState<any>(_.cloneDeep(FiltersInitialState));
        const [isLabSelectionOpen, setIsLabSelectionOpen] = useState(false);

        useEffect(() => {
            dispatch(setCurrentNavParams("Lab", "Lab"));
            dispatch(setSideMenuView('default'));
        }, [dispatch]);

        const handleSearch = useCallback((value: string) => {
            setFilterData((prevState: any) => ({
                ...prevState,
                search: value
            }));
        }, []);

        useEffect(() => {
            if (queryParamData) {
                const data: any = {
                    search: queryParamData.search || '',
                    startDate: queryParamData.startDate || '',
                    endDate: queryParamData.endDate || '',
                };
                if (queryParamData?.statuses?.length) {
                    data['statuses'] = queryParamData.statuses.split(',') || [];
                }
                data['statusesObjs'] = labStatusList.filter((item: any) => data['statuses']?.includes(item?.code));

                if (queryParamData?.createdByIds?.length) {
                    data['createdByIds'] = queryParamData.createdByIds.split(',') || [];
                }
                data['createdByObjs'] = userList.filter((item: any) => data['createdByIds']?.includes(item?.id?.toString()));

                if (queryParamData?.labTypes?.length) {
                    data['labTypes'] = queryParamData.labTypes.split(',') || [];
                }
                data['labTypesObjs'] = CommonService._staticData.labType.filter((item: any) => data['labTypes']?.includes(item?.code));

                if (queryParamData?.cities?.length) {
                    data['cities'] = queryParamData.cities.split(',') || [];
                }
                data['citiesObjs'] = citiesListLite.filter((item: any) => data['cities']?.includes(item?.city));

                setFilterData((prevState: any) => ({
                    ...prevState, ...data
                }));
            }
        }, [queryParamData, labStatusList, citiesListLite, userList]);

        const applyFilters = useCallback((filterData: any) => {
            setFilterData((prevState: any) => ({
                ...prevState,
                ...filterData
            }));
            setShowFiltersDrawer(false);
        }, []);

        useEffect(() => {
            CommonService.mapFilterDataToQueryParams(filterData, FILTERS_STATE_MANAGEMENT_EXCLUDE_KEYS);
        }, [filterData]);

        const clearAllFilters = useCallback(() => {
            setFilterData(_.cloneDeep(FiltersInitialState));
        }, []);

        const handleCreateLab = useCallback((labRoleType: LabRoleType) => {
            navigate(CommonService._routeConfig.LabCreateRoute(labRoleType));
        }, [navigate])

        return (
            <div className="lab-list-screen screen">
                <div className={"screen-content-wrapper"}>
                    <div className="page-data-wrapper">
                        <div className="page-options">
                            <div className="page-search">
                                <SearchComponent
                                    label={"Search"}
                                    placeholder={"Search by lab name"}
                                    id="search_input"
                                    value={filterData.search}
                                    onChange={handleSearch}
                                />
                            </div>
                            <div className="page-extra-options">
                                {CommonService.getAppliedFiltersCount(filterData, FILTERS_STATE_MANAGEMENT_EXCLUDE_KEYS) > 0 &&
                                    < ButtonComponent
                                        type="button"
                                        id="clear_all_filters"
                                        color={"secondary"}
                                        variant={"text"}
                                        fullWidth={false}
                                        handleClick={clearAllFilters}
                                    >
                                        Clear All
                                    </ButtonComponent>
                                }
                                <ButtonComponent
                                    type="button"
                                    id="csv_btn"
                                    color={"primary"}
                                    variant={"outlined"}
                                    fullWidth={false}
                                    handleClick={() => setShowFiltersDrawer(true)}
                                    startIcon={<FilterAltIcon/>}>
                                    Filters {CommonService.getAppliedFiltersCount(filterData, FILTERS_STATE_MANAGEMENT_EXCLUDE_KEYS) > 0 ? `( ${CommonService.getAppliedFiltersCount(filterData, FILTERS_STATE_MANAGEMENT_EXCLUDE_KEYS)} )` : ''}
                                </ButtonComponent>
                                {
                                    commonService.checkAccess('Lab', "labAdd", currentUser?.userAccessModules) &&
                                    <ButtonComponent
                                        type="button"
                                        color={"primary"}
                                        variant={"contained"}
                                        id="add_lab_btn"
                                        handleClick={() => setIsLabSelectionOpen(true)}
                                        startIcon={<AddIcon/>}
                                    >
                                        New Lab
                                    </ButtonComponent>
                                }
                            </div>

                        </div>
                        <>
                            <LabListComponent filterData={filterData}/>
                        </>
                    </div>
                </div>

                <DrawerComponent open={showFilterDrawer}
                                 className={"drawer-wrapper"}
                                 closeOnBackDropClick={true}
                                 closeOnEsc={true}
                                 onClose={() => setShowFiltersDrawer(false)}
                >
                    <LabFiltersComponent filtersData={filterData} onFiltersApply={applyFilters}
                                         setFilterData={setFilterData} FiltersInitialState={FiltersInitialState}/>
                </DrawerComponent>
                <LabRoleSelectionComponent
                    isOpen={isLabSelectionOpen}
                    onLabSelection={handleCreateLab}
                    onClose={() => {
                        setIsLabSelectionOpen(false);
                    }}
                    // currentLabRole={'sendLab'}
                />
            </div>
        );

    }

;

export default LabListScreen;
